import React from 'react';
import 'whatwg-fetch';
import { Message } from 'ykb-ui';

// const TOKEN_STORAGE_KEY = 'auth/TOKEN';

export const queryString = function(obj) {
  var params = Object.keys(obj)
    .filter(key => !!obj[key])
    .map(function(key) {
      return key + '=' + obj[key];
    })
    .join('&');
  return params;
};

function sanitizeEndpoint(endpoint) {
  return endpoint.charAt(0) !== '/' ? '/' + endpoint : endpoint;
}

export default function callApi(params = {}) {
  let apiParams = {
    method: 'GET',
    body: undefined,
    url: '',
    notifyErrors: true,
    showExceptionDetails: process.env.NODE_ENV === 'development',
    endpoint: null,
    silentMode: false,
  };

  if (typeof params === 'string') {
    apiParams.url = params;
  } else {
    apiParams = { ...apiParams, ...params };
    if (typeof apiParams.endpoint === 'string') {
      apiParams.url = `${process.env.REACT_APP_API}${sanitizeEndpoint(
        apiParams.endpoint
      )}`;
    }
  }

  /*
  let devAuthToken = {};
  if (window.sessionStorage) {
    const token = sessionStorage.getItem(TOKEN_STORAGE_KEY);
    if (token && token.length > 0) {
      devAuthToken.Authorization = 'Bearer ' + token;
    }
  }
  */

  if (window.onServiceCall) {
    window.onServiceCall(new Date());
  }

  let headers = {
    'Content-Type': 'application/json',
  };

  if (apiParams.IsFormData) {
    headers = {};
  }

  return fetch(apiParams.url, {
    method: apiParams.method,
    headers: {
      ...headers,
      ...apiParams.headers,
    },
    credentials: 'include',
    body: apiParams.IsFormData
      ? apiParams.body
      : JSON.stringify(apiParams.body),
  })
    .then(response => {
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response
          .clone()
          .json()
          .then(json => ({ json, response, text: null }));
      } else {
        return response
          .clone()
          .text()
          .then(text => ({ json: [], response, text }));
      }
    })
    .then(returnobject => {
      if (params.file) {
        return returnobject.response.blob().then(function(blob) {
          // var link = document.createElement('a');
          // link.href = window.URL.createObjectURL(blob);
          // link.download = '<FILENAME_TO_SAVE_WITH_EXTENSION>';
          // link.click();
          returnobject.blob = blob;
          return returnobject;
        });
      }
      return returnobject;
    })
    .then(({ json = [], response, text, blob }) => {
      // if (
      //   response.ok &&
      //   new URL(response.url).pathname === '/api/Auth/LoginCheckSms' &&
      //   window.sessionStorage
      // ) {
      //   sessionStorage.setItem(TOKEN_STORAGE_KEY, json.token);
      // }
      if (!response.ok) {
        // app might be hosted on subfolder
        if (
          response.status === 401 &&
          !(window.location.pathname || '').endsWith('/login')
        ) {
          window.location.href = `${process.env.PUBLIC_URL}/login`;
          return;
        }

        if (
          apiParams.silentMode === false &&
          (response.status === 403 || apiParams.notifyErrors)
        ) {
          let exceptionData =
            json.exceptionData || (json.length === 0 ? {} : json);
          let title = exceptionData.errorCode
            ? exceptionData.errorCode
            : response.status;
          let showDetails =
            exceptionData.showExceptionDetails === false
              ? false
              : apiParams.showExceptionDetails;

          let contentText =
            'Sunucu beklenmeyen bir durumla karşılaştı, daha sonra tekrar deneyiniz!';
          if (exceptionData.errorMessage) {
            contentText = exceptionData.errorMessage;
          } else if (text) {
            contentText = text;
          } else {
            const messages = [];
            if (typeof json === 'object' && json !== null) {
              for (const key of Object.keys(json)) {
                if (Array.isArray(json[key])) {
                  messages.push(...json[key]);
                }
              }
            }
            contentText =
              messages.length > 0 ? messages.join(' ') : contentText;
          }

          Message.error({
            title: 'Uyarı',
            content: (
              <div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: contentText,
                  }}
                ></div>

                {showDetails && (
                  <React.Fragment>
                    <br />
                    <pre style={{ fontSize: '12px' }}>
                      Hata Kodu: {title} {response.statusText}
                      <br />
                      Olay Takip Kodu: {exceptionData.traceId}
                      <br />
                      Uygulamadı Adı: {exceptionData.applicationName}
                      <br />
                    </pre>
                  </React.Fragment>
                )}
              </div>
            ),
          });
        }
        return Promise.reject(json);
      }
      if (params.file) {
        return blob;
      }
      return json;
    });
}
